import debug from 'debug'

export function getLogger(module: string) {
  return debug(`video-player:${module}`)
}
